title: Abonnement
actions:
  cancelMembership: Abonnement stopzetten
  cancelTrial: Proefperiode stopzetten
  confirmCancelMembership: Stopzetten bevestigen
  confirmResumeMembership: Heractiveren
  resumeMembership: Abonnement heractiveren
  manualPayment: Handmatige betalen via iDEAL
messages:
  managePayment: Hier zie je jouw abonnementstatus en facturen
  trialEndsAtUnknown: nader te bepalen
  cancelMembership:
    title: Abonnement stopzetten
    description: "Weet je zeker dat je wilt stoppen? Let op het volgende:\n\nEr volgt nog <strong>een laatste incasso</strong> voor de lopende periode. Na die betaling stopt het platform op <strong>{predictedSubscriptionEndsAtDate}</strong> en zijn al je gegevens niet meer bereikbaar."
  cancelTrial:
    title: Proefperiode stopzetten
    description: "Weet je zeker dat je wilt stoppen? Let op het volgende:\n\nJouw proefabonnement loopt nog tot <strong>{predictedSubscriptionEndsAtDate}</strong>. Daarna stopt het platform en zijn al je gegevens niet meer bereikbaar."
  resumeMembership:
    title: Abonnement heractiveren
    description: "Weet je zeker dat je het abonnement weer wilt heractiveren? Let op het volgende:\n\nHet abonnement zal doorgaan alsof het niet is gestopt."
  resumeMembershipSuccess:
    dialogTitle: Abonnement heractiveren
    title: Heractiveren gelukt
    description: "Het abonnement is weer geactiveerd en je kan 4YourPlan blijven gebruiken zoals je gewend bent."
  trial:
    title: Proefperiode actief
    description: "Je proefperiode loopt tot {trialEndsAtDate}. Daarna wordt automatisch het eerste bedrag geïncasseerd."
  paid:
    title: Betaling ontvangen
    description: "Betaald op {previousPaymentDate}. Je volgende automatische betaling is op {nextPaymentDate}."
  failed:
    title: Betaling mislukt
    description: "De incasso van {failedPaymentDate} is mislukt. Betaal de openstaande factuur zo snel mogelijk om onderbreking van de dienst te voorkomen."
  canceled:
    title: Abonnement stopgezet
    description: "Je abonnement is opgezegd. Je hebt nog toegang tot het platform tot {subscriptionEndsAtDate}, waarna je account wordt gesloten."
